import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ChevronDown, Check } from "lucide-react";

let cache = null;
export const useTaxonomy = () => {
  const [t, setT] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/categories").then((r) => { cache = r.data; setT(r.data); });
  }, []);
  return t;
};

export const AREA_LABEL = { artist: "Artista / Performer", supplier: "Fornitore di Servizi" };
const OTHER = "Altro";

const Macro = ({ area, macro, subs, picked, other, onToggle, onOther, withOther, testPrefix }) => {
  const [open, setOpen] = useState(false);
  const n = picked.length;
  return (
    <div className="border border-slate-200 rounded-xl overflow-hidden" data-testid={`${testPrefix}-macro-${macro}`}>
      <button type="button" onClick={() => setOpen(!open)} data-testid={`${testPrefix}-open-${macro}`}
        className={`w-full flex items-center justify-between gap-3 px-4 py-3 text-left text-sm transition-colors ${n ? "bg-gold/10" : "hover:bg-slate-50"}`}>
        <span className="font-semibold text-navy">{macro}</span>
        <span className="flex items-center gap-2">{n > 0 && <span className="chip-gold text-[11px]">{n}</span>}<ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`}/></span>
      </button>
      {open && (
        <div className="px-4 pb-4 pt-1 flex flex-wrap gap-2">
          {subs.map((s) => {
            const on = picked.includes(s);
            return (
              <button type="button" key={s} onClick={() => onToggle(area, macro, s)} data-testid={`${testPrefix}-sub-${macro}-${s}`} aria-pressed={on}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs border transition-colors ${on ? "bg-navy text-white border-navy" : "border-slate-300 hover:border-gold"}`}>
                <span className={`w-3.5 h-3.5 rounded-sm border flex items-center justify-center ${on ? "bg-gold border-gold" : "border-slate-400"}`}>{on && <Check className="w-2.5 h-2.5 text-navy"/>}</span>{s}
              </button>
            );
          })}
          {withOther && picked.includes(OTHER) && (
            <input data-testid={`${testPrefix}-other-${macro}`} value={other || ""} onChange={(e) => onOther(macro, e.target.value)} maxLength={120}
              placeholder="Specifica cosa fai (es. Mimo, Arpista…)" className="w-full mt-1 border border-slate-300 rounded-full px-4 py-2 text-sm"/>
          )}
        </div>
      )}
    </div>
  );
};

export const TaxonomyPicker = ({ areas, value, other = {}, onChange, withOther = true, testPrefix = "tax" }) => {
  const t = useTaxonomy();
  if (!t) return <p className="text-sm text-slate-500">Caricamento categorie…</p>;
  const toggle = (area, macro, sub) => {
    const sel = { ...(value[area] || {}) };
    const cur = sel[macro] || [];
    sel[macro] = cur.includes(sub) ? cur.filter((x) => x !== sub) : [...cur, sub];
    if (!sel[macro].length) delete sel[macro];
    onChange({ ...value, [area]: sel }, other);
  };
  const setOther = (macro, text) => onChange(value, { ...other, [macro]: text });
  return (
    <div className="space-y-6">
      {areas.map((area) => (
        <div key={area} data-testid={`${testPrefix}-area-${area}`}>
          <div className="overline text-gold mb-2">{AREA_LABEL[area]}</div>
          <div className="grid md:grid-cols-2 gap-2 items-start">
            {Object.entries(t[area]).map(([macro, subs]) => (
              <Macro key={macro} area={area} macro={macro} subs={subs} picked={(value[area] || {})[macro] || []} other={other[macro]}
                onToggle={toggle} onOther={setOther} withOther={withOther} testPrefix={testPrefix}/>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export const toTokens = (value, areas) => areas.flatMap((a) => Object.entries(value[a] || {}).flatMap(([m, subs]) => subs.map((s) => `${m}::${s}`)));
